import { render, staticRenderFns } from "./OrderModelX.vue?vue&type=template&id=4649384a&scoped=true&"
import script from "./OrderModelX.vue?vue&type=script&lang=js&"
export * from "./OrderModelX.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4649384a",
  null
  
)

export default component.exports